// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3Jn1L","disabled":"FileBtn_disabled__L_M-X","warn":"FileBtn_warn__28Joe","fade":"FileBtn_fade__3Usbu"};